import {
  getQueryStringWithoutParamList
} from './url_utils.js';

// strip the specified GET param using history.replaceState
// uses window.location to determine the pieces of the URL
export const stripParamsAndReplaceState = (targetWindow, paramKeyList)=> {
  const location = targetWindow.location;
  const history = targetWindow.history;
  if ('replaceState' in history && location.search) {
    var newQueryString = getQueryStringWithoutParamList(location.search, paramKeyList);
    history.replaceState(
      '', 
      '', 
      location.pathname + newQueryString + location.hash
    );
  }
};

